import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS  } from '@angular/material';
import * as XLSX from 'xlsx';
import { SecurityService } from 'app/services/security/security.service';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FiltrosRepFinanzas } from 'app/models/FiltrosRepFinanzas';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-operaciones-estado',
  templateUrl: './listado-operaciones-estado.component.html',
  styleUrls: ['./listado-operaciones-estado.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class ListadoOperacionesEstadoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns =  [ 'NUMERO_OPERACION','CODIGO_ORDEN',
  'EJECUT',
  'RUC_CLIENTE',
  'RAZON_SOCIAL_CLIENTE','CODIGO_FN',
  'FACTURA_NEGOCIADA',
  'VALOR_NOMINAL',
  'RUC_DEUDOR',
  'RAZON_SOCIAL_DEUDOR',
  'MONEDA',
  'TEM','TASA_ALL_IN','TC',
  'FECHA_OPERACION',
  'FECHA_VENCIMIENTO',
  'FECHA_PAGO_REAL','DIAS_ATRASO','INTERESES_DESCONTADOS','COMISION_ESTRUCTURACION',
  'IGV_COMISION_ESTRUCTURACION','IGV_INTERES_DESCONTADOS','TOTAL_DESCUENTO','CAVALI','FIRMA_ELECTRONICA','OTROS','IGV','TOTAL_COSTOS', 
  'RETENCION'];
;
headerStyle:any = [
  {cell:'A2',cells:'A1:A2',fgColor:'002060',color:'FFFFFF'},
  {cell:'B2',cells:'B1:B2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'C2',cells:'C1:C2',fgColor:'002060',color:'FFFFFF'},
  {cell:'D2',cells:'D1:D2',fgColor:'002060',color:'FFFFFF'},
  {cell:'E2',cells:'E1:E2',fgColor:'002060',color:'FFFFFF'},
  {cell:'F2',cells:'F1:F2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'G2',cells:'G1:G2',fgColor:'002060',color:'FFFFFF'},
  {cell:'H2',cells:'H1:H2',fgColor:'002060',color:'FFFFFF'},
  {cell:'I2',cells:'I1:I2',fgColor:'002060',color:'FFFFFF'},
  {cell:'J2',cells:'J1:J2',fgColor:'002060',color:'FFFFFF'},
  {cell:'K2',cells:'K1:K2',fgColor:'002060',color:'FFFFFF'},
  {cell:'L2',cells:'L1:L2',fgColor:'002060',color:'FFFFFF'},
  {cell:'M2',cells:'M1:M2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'N2',cells:'N1:N2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'O2',cells:'O1:O2',fgColor:'002060',color:'FFFFFF'},
  {cell:'P2',cells:'P1:P2',fgColor:'002060',color:'FFFFFF'},
  {cell:'Q2',cells:'Q1:Q2',fgColor:'FFC000',color:'FFFFFF'},
  {cell:'R2',cells:'R1:R2',fgColor:'002060',color:'FFFFFF'},
  
  {cell:'S1',cells:'S1:W1',fgColor:'00B0F0',color:'FFFFFF',title:'INTERESES & COMISIONES'},
  {cell:'S2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'T2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'U2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'V2',fgColor:'00B0F0',color:'FFFFFF'},
  {cell:'W2',fgColor:'00B0F0',color:'FFFFFF'},

  {cell:'X1',cells:'X1:AB1',fgColor:'002060',color:'FFFFFF',title:'COSTOS DE OPERACIÓN'},
  {cell:'X2',fgColor:'002060',color:'FFFFFF'},
  {cell:'Y2',fgColor:'002060',color:'FFFFFF'},
  {cell:'Z2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AA2',fgColor:'002060',color:'FFFFFF'},
  {cell:'AB2',fgColor:'002060',color:'FFFFFF'},

  {cell:'AC2',cells:'AC1:AC2',fgColor:'002060',color:'FFFFFF'},
];
  footerStyle:any=[
    {fgColor:'808080',color:'FFFFFF',content:'TOTAL'},
    {fgColor:'808080',color:'FFFFFF',formula:'SUM',col:'E'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
  ]
  abrirDetalleConciliacion: boolean = false;
  loading: boolean;
  loadingUser:boolean;
  planillas: any = [];
  dataReporte: any = [];
  dataSource: any;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  arrListaAccesos: any[] = [];
  subRepFinanzas: Subscription = new Subscription();
  DTOFiltrosRepFinanzas: FiltrosRepFinanzas = new FiltrosRepFinanzas();
  arrListaRoles: any[] = [];
  usuarioLogueado: any;
  usuarioFiltro: any;
  rolUsuario: any;
  readonly ROL_ADMIN: string = 'administrador';
  readonly ROL_COMERCIAL: string = 'comercial';
  readonly ROL_JEFATURA: string = 'jefe';
  readonly ROL_GERENCIA: string = 'gerencia';
  subLista: Subscription[] = [];
  subRol: Subscription = new Subscription();
  subAcceso: Subscription = new Subscription();
  subUser: Subscription = new Subscription();
  constructor(private reporteService: ReportesService,
    private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus) { }

  ngOnInit() {
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('UserActive'));
    this.obtenerListaAccesos();
    this.ListadoRepFinanzas();
    this.securityService.headerStyle=this.headerStyle;
    this.securityService.footerStyle=this.footerStyle;
    this.securityService.displayedColumns=this.displayedColumns;
  }
  obtenerListaAccesos() {
    this.subRol = this.securityService.ObtenerListaRoles(this.usuarioLogueado.id_empresa).subscribe(
      (resRoles: any) => {
        this.arrListaRoles = resRoles;
        this.rolUsuario = this.arrListaRoles.find(r => r.id_roles == this.usuarioLogueado.id_roles);
        this.rolUsuario.Nombre = this.rolUsuario.Nombre.toLowerCase();

        this.subAcceso = this.securityService.ObtenerListaAccesos().subscribe(
          (resAccesos: any) => {
            this.arrListaAccesos = resAccesos;
            if (this.rolUsuario.Nombre.startsWith(this.ROL_JEFATURA) || this.rolUsuario.Nombre == this.ROL_GERENCIA || this.rolUsuario.Nombre == this.ROL_ADMIN) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_roles_dsc.toLowerCase() == this.ROL_COMERCIAL);
            } else if (this.rolUsuario.Nombre == this.ROL_COMERCIAL) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_user == this.usuarioLogueado.id_user);
            } else {
              this.arrListaAccesos = [];
            }
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "LISTA ACCESOS NO OBTENIDA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );

        this.subLista.push(this.subAcceso);

      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subRol);
  }
  ListadoRepFinanzas(){
    this.loading = true;
    this.DTOFiltrosRepFinanzas.Tipo = 'operaciones_estado';
    this.subRepFinanzas = this.securityService.FiltroListadoRepFinanzas(this.DTOFiltrosRepFinanzas, this.datePipe.transform(this.fechaD, 'yyyy-MM-dd'), this.datePipe.transform(this.fechaH, 'yyyy-MM-dd')).subscribe(
      res => {
        this.dataReporte = res;
        this.dataSource = new MatTableDataSource(this.dataReporte);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        this.securityService.dataBuffer = this.dataReporte;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPORTE NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }
  seleccionarUsuario(event) {
    this.loadingUser = true;
    Swal.fire({
      title: 'Espere',
      text: 'Obteniendo datos del usuario seleccionado',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    let TipoUsuario = "COM";
    this.subUser = this.securityService.ObtenerUsuarios(TipoUsuario).subscribe(
      res => {

        this.usuarioFiltro = res;
        this.usuarioFiltro = this.usuarioFiltro.filter(u => u.Nombre == event);
        this.DTOFiltrosRepFinanzas.Usuario = this.usuarioFiltro[0].Usuario;
        this.loadingUser = false;
        if (this.loadingUser == false) {
          Swal.close();
        }

      },
      (err: HttpErrorResponse) => {

        this.loadingUser = false;
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "DATOS DEL USUARIO NO OBTENIDOS. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subUser);
  }
}


